import { toast } from 'react-toastify';

/**
 * The link to the crew's Open shifts tab — the same one an open-shift text carries (server/services/openShift).
 * Owner, Oct 7 2026: "make a link I can copy for open shifts." It is one link for everybody: each person signs in
 * with their own PIN and sees only the shifts offered to them; someone not signed in lands back on it after the PIN.
 */
export const openShiftLink = () => `${window.location.origin}/crew/jobs?tab=open`;

/** Copy it; say what it is. Where the clipboard is not allowed, show it so it can be copied by hand. */
export function copyOpenShiftLink() {
  const url = openShiftLink();
  const done = () => toast.success('Open-shift link copied — paste it anywhere. Each person signs in with their own PIN.');
  const byHand = () => { window.prompt('Copy this link', url); };
  try {
    if (navigator.clipboard?.writeText) navigator.clipboard.writeText(url).then(done).catch(byHand);
    else byHand();
  } catch { byHand(); }
}
